import React from "react";
import styles from "./index.module.scss";
export var Section = function () {
    return React.createElement("div", { className: styles.container },
        React.createElement("h1", null,
            "Lorem ipsum dolor sit ",
            React.createElement("span", { className: styles.ul }, "amet"),
            "."),
        React.createElement("div", { className: styles.reasons },
            React.createElement("div", null,
                React.createElement("h3", null, "Lorem, ipsum."),
                React.createElement("p", null, "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ab, deleniti.")),
            React.createElement("div", null,
                React.createElement("h3", null, "Autem, unde?"),
                React.createElement("p", null, "Asperiores culpa quia id quam dicta quos mollitia inventore impedit.")),
            React.createElement("div", null,
                React.createElement("h3", null, "Voluptates, alias?"),
                React.createElement("p", null, "Culpa possimus similique eos iusto, est laboriosam? Reiciendis, odit provident?")),
            React.createElement("div", null,
                React.createElement("h3", null, "Illo, totam."),
                React.createElement("p", null, "Consequuntur debitis unde placeat nulla possimus inventore nemo iure. Et?"))));
};
